import ModulesDoneModal from '@/common/containers/Modals/ModulesDoneModal/ModulesDoneModal';

export default ModulesDoneModal;
